import { AuthCrudHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**mpfAuthCrudHttp:
 * .
 */
const mpfAuthCrudHttp = () => {
  try {
    return new AuthCrudHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint AuthCrudHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)
    throw error
  }
}

export { mpfAuthCrudHttp }
